var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadgeKia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00001E",
    d: "M32.5 12.4c0 .1 0 .2.1.2 0 0 .1 0 .1-.1L50.2.5c.3-.2.6-.3 1-.3H55c.6 0 1 .4 1 1V9c0 .9-.2 1.5-1 2l-4.7 3c-.1 0-.1.1-.2.1s-.1 0-.1-.2V4.8c0-.1 0-.2-.1-.2 0 0-.1 0-.1.1L37 13.5c-.4.2-.7.3-1 .3h-8.5c-.6 0-1-.4-1-1V1.6c0-.1 0-.2-.1-.2 0 0-.1 0-.1.1L18 6.7l-.1.1s0 .1.1.1l6 6.4c.1.1.1.2.1.2 0 .1-.1.1-.2.1h-5.4c-.4 0-.8-.1-1-.3l-3.6-3.9-.1-.1h-.1l-6.1 3.9c-.4.2-.6.3-1 .3H1c-.6 0-1-.4-1-1V5c0-.9.2-1.5 1-2l4.7-3h.1c.1 0 .1.1.1.3v10.2c0 .1 0 .2.1.2 0 0 .1 0 .1-.1L22 .5c.4-.2.6-.3 1-.3h8.5c.6 0 1 .4 1 1v11.2z"
  })));
}

export default SvgBadgeKia;